<template>
  <div>
    <nav>
      <img class="nav-icon" src="../../assets/images/leaf-icon.png" />
      <div class="nav-content">
        <button
          ref="backButton"
          class="action-button"
          @click="backHandler()"
          v-show="!returnMode"
        >
          <!-- <i class="fa fa-chevron-left"></i> -->
          <img src="../../assets/images/back-icon.png" />
          <span>Back</span>
        </button>
        <button
          ref="forwardButton"
          class="action-button"
          @click="forwardHandler()"
          v-show="!returnMode"
        >
          <!-- <i class="fa fa-chevron-right"></i> -->
          <img src="../../assets/images/forward-icon.png" />
          <span>Forward</span>
        </button>
        <button class="action-button" v-show="false">
          <img src="../../assets/images/overview-icon.png" />
          <span>Overview</span>
        </button>
        <button
          class="action-button"
          :disabled="notifictaionCounter <= 0 || intermediateViewDisplayed"
          v-on:click="showActions()"
          v-show="!returnMode"
        >
          <i class="fa fa-layer-group"></i>
          <span>Actions</span>
          <span v-show="notifictaionCounter > 0" class="notification">{{
            notifictaionCounter
          }}</span>
        </button>
        <button
          class="action-button"
          :disabled="intermediateViewDisplayed"
          v-on:click="doneNotification()"
          v-show="returnMode"
        >
          <i class="fa fa-layer-group"></i>
          <span>Done</span>
        </button>

        <actions
          :appMessages="messages"
          :messageAppsSettings="msgRcvSetting"
          :openActionMenue="actionsMenuOpened"
          v-on:message-selected="messageSelecteted"
          v-on:close-action-menue="closeActions"
          :returnMode="returnMode"
        ></actions>
      </div>
    </nav>
  </div>
</template>

<script>
import _ from "lodash";
import portalAPI from "../../services/portalService";
import Actions from "./../viewMode/Actions";

export default {
  name: "FrameNav",

  components: {
    Actions,
  },

  props: [
    "messages",
    "currentNodeId",
    "nodeUniqueId",
    "intermediateViewDisplayed",
    "returnMode",
  ],

  computed: {
    notifictaionCounter: function () {
      if (this.messages.length > 0) {
        var counter = this.messages.reduce(
          (accumulator, currentValue) =>
            accumulator +
            (currentValue.groupChild.filter.length > 0
              ? currentValue.groupChild.length
              : 1),
          0
        );
        return counter;
      } else return 0;
    },
  },
  data: function () {
    return {
      pAPI: new portalAPI(),
      msgRcvSetting: null,
      forwardNodes: null,
      actionsMenuOpened: false,
    };
  },

  methods: {
    messageSelecteted(messages, nodeId, mode = false) {
      this.$emit("message-selected", messages, nodeId, mode);
    },
    doneNotification() {
      //console.log("emit(cycle-completion-notification)");
      this.$emit("cycle-completion-notification");
    },
    showActions: function () {
      this.actionsMenuOpened = true;
    },
    closeActions: function () {
      this.actionsMenuOpened = false;
    },
    forwardHandler() {
      if (this.actionsMenuOpened) {
        this.closeActions();
      }
      this.$emit("forward");
    },
    backHandler() {
      this.$emit("back");
    },
    disableBackwardButton() {
      this.$refs.backButton.disabled = true;
    },
    disableforwardButton() {
      this.$refs.forwardButton.disabled = true;
    },
    enableBackwardButton() {
      this.$refs.backButton.disabled = false;
    },
    enableforwardButton() {
      this.$refs.forwardButton.disabled = false;
    },
    getNavMsgSettings: function () {
      let that = this;

      that.pAPI.getMessageRecieverSettings().then((res) => {
        let tempdata = _.groupBy(res.data, "nodeName");
        that.msgRcvSetting = Object.keys(tempdata)
          .map((n) => ({
            nodeName: n,
            nodeId: tempdata[n][0].nodeId,
            nodeSettings: tempdata[n].map((s) => ({
              messageType: s.messageType,
              messageTypeId: s.messageTypeId,
              messageItemCount: s.message_item_count,
              messageReturnMode: s.message_returned_mode,
            })),
          }))
          .filter((node) => node.nodeId != that.currentNodeId);
      });
    },
  },
  watch: {},
  mounted() {
    this.getNavMsgSettings();
    this.disableforwardButton();
    this.disableBackwardButton();
  },
};
</script>

<style>
.nav-icon {
  margin: 20px 0 0 19px;
  width: 40px;
  text-align: center;
  display: var(--nav_icon);
}
</style>